import { PRODUCT_NAME } from '@classgo/shared/brand';

/**
 * Strings of the school app on top of the kit's: navigation, shell, home and account screens.
 */
export const webMessages = {
  'app.name': PRODUCT_NAME,
  'app.tagline': 'La operación del colegio en un solo lugar',
  'nav.main': 'Principal',
  'nav.home': 'Inicio',
  'home.family.title': 'Sus estudiantes',
  'home.family.empty': 'Todavía no hay estudiantes vinculados a su cuenta.',
  'home.family.notEnrolled': 'Sin matrícula este año',
  'nav.account': 'Mi cuenta',
  'shell.sede': 'Sede',
  'home.title': 'Inicio',
  'home.welcome': 'Hola, {name}',
  'home.context': 'Está viendo {tenant} · {sede}',
  'home.next': 'Los módulos académicos llegan en las próximas entregas.',
  'account.title': 'Mi cuenta',
  'account.email': 'Correo',
  'account.name': 'Nombre',
  'account.roles': 'Roles',
  'account.permissions': 'Permisos',
  'account.permissions.all': 'Acceso completo',
  'account.guides.title': 'Guías de uso',
  'account.guides.body':
    'La rutina del día y la del periodo, paso a paso, con la pantalla, los clics y el tiempo de cada una.',
  'account.guides.teacher': 'Guía del docente (la app)',
  'account.guides.admin': 'Guía de administración (la web)',
  'actAs.banner': `Está actuando como equipo ${PRODUCT_NAME} en {tenant} hasta las {until}.`,
  'actAs.leave': 'Salir del colegio',
  'actAs.invalid.title': 'Enlace no válido',
  'actAs.invalid.body': `El acceso como equipo ${PRODUCT_NAME} expiró o está incompleto. Ábralo de nuevo desde la consola.`,
  'staffNotice.title': 'Esta es la aplicación de los colegios',
  'staffNotice.body': `Su cuenta pertenece al equipo de ${PRODUCT_NAME}. Use la consola de ${PRODUCT_NAME} para administrar colegios o para entrar como uno de ellos.`,
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.none': '—',
  'nav.setup': 'Puesta en marcha',
  'nav.checklist': 'Lista de configuración',
  'nav.imports': 'Importar datos',
  'setup.title': 'Puesta en marcha del colegio',
  'setup.progress': '{done} de {total} pasos listos',
  'setup.ready': 'Todo listo para el primer día.',
  'setup.go': 'Ir',
  'setup.skip': 'No lo usamos',
  'setup.unskip': 'Volver a incluir',
  'setup.status.done': 'Listo',
  'setup.status.pending': 'Pendiente',
  'setup.status.skipped': 'Omitido',
  'imports.title': 'Importar datos',
  'imports.intro': `Elija qué va a importar, descargue la plantilla, llénela y súbala. ${PRODUCT_NAME} la revisa antes de guardar nada.`,
  'imports.step.file': 'Archivo de {entity}',
  'imports.step.review': 'Revisión de {entity}',
  'imports.step.status': 'Importación de {entity}',
  'imports.downloadTemplate': 'Descargar plantilla',
  'imports.downloadCurrent': 'Descargar con los datos actuales',
  'imports.back': 'Elegir otra entidad',
  'imports.columns': 'Columnas de la plantilla',
  'imports.file': 'Archivo CSV',
  'imports.file.help': 'Exportado desde Excel o Google Sheets; separador ; o , y tildes bien.',
  'imports.validating': 'Revisando el archivo…',
  'imports.error.dryRun': 'No se pudo revisar el archivo',
  'imports.error.apply': 'No se pudo iniciar la importación',
  'imports.review.file': '{name} · codificación {encoding} · separador {separator}',
  'imports.review.unknownColumns': 'Columnas ignoradas: {columns}',
  'imports.review.clean': 'Todas las filas están bien.',
  'imports.review.tableCaption': 'Filas con errores o advertencias',
  'imports.review.more': '… y {count} filas más con observaciones.',
  'imports.totals.rows': 'Filas',
  'imports.totals.ok': 'Válidas',
  'imports.totals.errors': 'Con error',
  'imports.totals.create': 'Nuevas',
  'imports.totals.update': 'Actualizan',
  'imports.row.line': 'Fila',
  'imports.row.status': 'Estado',
  'imports.row.error': 'Error',
  'imports.row.warning': 'Advertencia',
  'imports.row.issues': 'Observaciones',
  'imports.apply': 'Importar {count} filas válidas',
  'imports.anotherFile': 'Subir otro archivo',
  'imports.status.queued': 'En cola',
  'imports.status.running': 'En curso',
  'imports.status.done': 'Completada',
  'imports.status.failed': 'Con fallas',
  'imports.status.wait': 'Esto tarda unos segundos…',
  'imports.counts':
    '{rows} filas: {created} creadas, {updated} actualizadas, {unchanged} sin cambios, {errors} con error',
  'imports.errorFile': 'Descargar las {count} filas con error (corríjalas y súbalas de nuevo)',
  'imports.again': 'Importar otro archivo',
  'nav.structure': 'Estructura académica',
  'nav.sedes': 'Sedes',
  'nav.years': 'Años escolares',
  'nav.levels': 'Niveles y grados',
  'nav.groups': 'Grupos',
  'nav.subjects': 'Asignaturas',
  'nav.classrooms': 'Aulas',
  'entity.delete': 'Eliminar',
  'entity.delete.title': '¿Eliminar?',
  'entity.delete.body': 'Se eliminará "{name}". Los registros que dependen de él lo impiden.',
  'entity.deleted': 'Eliminado.',
  'entity.error.title': 'No se pudo cargar la lista',
  'sedes.title': 'Sedes',
  'sedes.caption': 'Sedes del colegio',
  'sedes.new': 'Nueva sede',
  'sedes.edit': 'Editar sede',
  'sedes.empty.title': 'Sin sedes',
  'sedes.empty.body': 'Todo colegio tiene al menos una sede principal.',
  'sedes.column.name': 'Sede',
  'sedes.column.address': 'Dirección',
  'sedes.column.dane': 'Código DANE de sede',
  'sedes.main': 'Principal',
  'sedes.field.name': 'Nombre de la sede',
  'sedes.field.address': 'Dirección',
  'sedes.field.daneSedeCode': 'Código DANE de la sede',
  'sedes.field.daneSedeCode.help': 'El consecutivo de sede del DANE, si el colegio lo tiene.',
  'sedes.field.isMain': 'Sede principal',
  'sedes.field.isMain.help': 'La que aparece primero y representa al colegio.',
  'years.title': 'Años escolares',
  'years.caption': 'Años escolares',
  'years.new': 'Nuevo año escolar',
  'years.edit': 'Editar año escolar',
  'years.empty.title': 'Sin años escolares',
  'years.empty.body': 'Cree el año escolar y luego sus periodos.',
  'years.column.name': 'Año',
  'years.column.calendar': 'Calendario',
  'years.column.dates': 'Fechas',
  'years.column.status': 'Estado',
  'years.field.name': 'Nombre',
  'years.field.calendar': 'Calendario',
  'years.field.calendar.help':
    'Calendario A: de enero a noviembre. Calendario B: de agosto a junio.',
  'years.field.startsOn': 'Inicia',
  'years.field.endsOn': 'Termina',
  'years.calendar.A': 'Calendario A',
  'years.calendar.B': 'Calendario B',
  'years.status.planned': 'Planeado',
  'years.status.active': 'Activo',
  'years.status.closed': 'Cerrado',
  'years.activate': 'Activar año',
  'years.activate.title': '¿Activar {name}?',
  'years.activate.body': 'Será el año en curso del colegio. El año activo actual pasará a cerrado.',
  'years.activated': 'Año activado.',
  'years.detail.dates': '{from} → {to}',
  'periods.title': 'Periodos',
  'periods.caption': 'Periodos del año',
  'periods.new': 'Nuevo periodo',
  'periods.edit': 'Editar periodo',
  'periods.empty.title': 'Sin periodos',
  'periods.empty.body': 'Divida el año en periodos: tres o cuatro es lo habitual.',
  'periods.column.position': 'N.º',
  'periods.column.name': 'Periodo',
  'periods.column.dates': 'Fechas',
  'periods.column.status': 'Estado',
  'periods.field.name': 'Nombre',
  'periods.field.position': 'N.º',
  'periods.field.startsOn': 'Inicia',
  'periods.field.endsOn': 'Termina',
  'periods.defaultName': 'Periodo {n}',
  'periods.open': 'Abrir',
  'periods.close': 'Cerrar',
  'periods.opened': 'Periodo abierto.',
  'periods.closed': 'Periodo cerrado.',
  'periods.timeline': 'Línea de tiempo del año',
  'periods.timeline.gap': 'sin periodo',
  'levels.title': 'Niveles',
  'levels.caption': 'Niveles del colegio',
  'levels.new': 'Nuevo nivel',
  'levels.edit': 'Editar nivel',
  'levels.empty.title': 'Sin niveles',
  'levels.empty.body': 'Preescolar, Primaria, Secundaria y Media, o los que el colegio defina.',
  'levels.column.name': 'Nivel',
  'levels.column.position': 'Orden',
  'levels.field.name': 'Nombre',
  'levels.field.position': 'Orden',
  'grades.title': 'Grados',
  'grades.caption': 'Grados del nivel',
  'grades.new': 'Nuevo grado',
  'grades.edit': 'Editar grado',
  'grades.empty.title': 'Sin grados',
  'grades.empty.body': 'Los grados del nivel seleccionado: Transición, Primero, Segundo…',
  'grades.column.name': 'Grado',
  'grades.column.position': 'Orden',
  'grades.field.level': 'Nivel',
  'grades.field.name': 'Nombre',
  'grades.field.position': 'Orden',
  'grades.filter.level': 'Grados del nivel',
  'grades.noLevel': 'Cree un nivel primero.',
  'groups.title': 'Grupos',
  'groups.caption': 'Grupos de la sede',
  'groups.new': 'Nuevo grupo',
  'groups.edit': 'Editar grupo',
  'groups.empty.title': 'Sin grupos',
  'groups.empty.body': 'Los grupos de esta sede en el año seleccionado: Primero A, Primero B…',
  'groups.column.name': 'Grupo',
  'groups.column.grade': 'Grado',
  'groups.column.jornada': 'Jornada',
  'groups.field.year': 'Año escolar',
  'groups.field.sede': 'Sede',
  'groups.field.grade': 'Grado',
  'groups.field.name': 'Nombre del grupo',
  'groups.field.name.help': 'Por ejemplo "Primero A".',
  'groups.field.jornada': 'Jornada',
  'groups.jornada.unica': 'Única',
  'groups.jornada.manana': 'Mañana',
  'groups.jornada.tarde': 'Tarde',
  'groups.jornada.nocturna': 'Nocturna',
  'groups.filter.year': 'Año escolar',
  'groups.noYear': 'Cree un año escolar primero.',
  'groups.noGrade': 'Cree un grado primero',
  'groups.sedeNote': 'Sede: {sede}',
  'subjects.title': 'Asignaturas',
  'subjects.caption': 'Asignaturas del colegio',
  'subjects.new': 'Nueva asignatura',
  'subjects.edit': 'Editar asignatura',
  'subjects.empty.title': 'Sin asignaturas',
  'subjects.empty.body': 'Matemáticas, Lengua castellana, Ciencias naturales…',
  'subjects.column.name': 'Asignatura',
  'subjects.column.code': 'Código',
  'subjects.field.name': 'Nombre',
  'subjects.field.code': 'Código',
  'subjects.field.code.help': 'Abreviatura para horarios y boletines, por ejemplo MAT.',
  'classrooms.title': 'Aulas',
  'classrooms.caption': 'Aulas de la sede',
  'classrooms.new': 'Nueva aula',
  'classrooms.edit': 'Editar aula',
  'classrooms.empty.title': 'Sin aulas',
  'classrooms.empty.body': 'Las aulas de esta sede, con su capacidad.',
  'classrooms.column.name': 'Aula',
  'classrooms.column.capacity': 'Capacidad',
  'classrooms.field.sede': 'Sede',
  'classrooms.field.name': 'Nombre',
  'classrooms.field.capacity': 'Capacidad',
  'scale.title': 'Escala de valoración',
  'scale.help': 'La escala del colegio y su equivalencia con la escala nacional (Decreto 1290).',
  'scale.field.kind': 'Tipo',
  'scale.kind.numeric': 'Numérica',
  'scale.kind.qualitative': 'Cualitativa',
  'scale.field.minScore': 'Nota mínima',
  'scale.field.maxScore': 'Nota máxima',
  'scale.field.passMark': 'Nota de aprobación',
  'scale.bands': 'Escala nacional',
  'scale.bands.reset': 'Restablecer la nacional',
  'scale.band.label': 'Desempeño',
  'scale.band.from': 'Desde (%)',
  'scale.band.to': 'Hasta (%)',
  'scale.preview': 'En la escala del colegio',
  'scale.preview.range': '{from} – {to}',
  'scale.save': 'Guardar escala',
  'scale.saved': 'Escala guardada.',
  'scale.notConfigured': 'Este año aún no tiene escala; al guardar quedará configurada.',
  'nav.community': 'Comunidad',
  'nav.students': 'Estudiantes',
  'nav.teachers': 'Docentes',
  'nav.academics': 'Vida académica',
  'nav.timetable': 'Horario',
  'nav.attendance': 'Asistencia',
  'nav.grades': 'Calificaciones',
  'nav.reportCards': 'Boletines',
  'nav.announcements': 'Comunicados',
  'nav.guardians': 'Acudientes',
  'people.field.givenName': 'Nombres',
  'people.field.familyName': 'Apellidos',
  'people.field.documentType': 'Tipo de documento',
  'people.field.documentNumber': 'Número de documento',
  'people.field.birthDate': 'Fecha de nacimiento',
  'people.field.email': 'Correo',
  'people.field.phone': 'Teléfono',
  'students.new': 'Nuevo estudiante',
  'student.edit': 'Editar',
  'student.delete': 'Eliminar estudiante',
  'student.delete.body':
    '¿Eliminar a {name}? Sus registros se conservan para retención; deja de aparecer en las listas.',
  'student.photo': 'Cambiar foto',
  'student.field.email.help': 'Opcional para menores: reciben acceso por su acudiente.',
  'student.enroll.group': 'Grupo',
  'student.enroll.help': 'Matrícula en el año lectivo {year}.',
  'student.enroll.noYear': 'No hay un año lectivo activo.',
  'student.enroll.later': 'Sin matrícula por ahora',
  'student.enroll.enrolledOn': 'Fecha de matrícula',
  'student.enroll.none': 'Sin matrícula este año',
  'student.enroll.now': 'Matricular',
  'student.enroll.move': 'Cambiar de grupo',
  'student.status.change': 'Cambiar estado',
  'student.status.confirm': 'Registrar cambio',
  'student.status.effectiveOn': 'Fecha efectiva',
  'student.status.reason': 'Motivo',
  'student.status.keepsRecords': 'Las calificaciones y la asistencia del año siguen consultables.',
  'student.enrollment.status.active': 'activa',
  'student.enrollment.status.withdrawn': 'retirada',
  'student.enrollment.status.transferred': 'trasladada',
  'student.enrollment.status.completed': 'completada',
  'student.history': 'Historial',
  'student.history.enrollments': 'Matrículas',
  'student.history.status': 'Estados',
  'student.account': 'Crear cuenta de acceso',
  'student.account.help': 'Cognito envía una contraseña temporal al correo del estudiante.',
  'student.account.created': 'Cuenta creada',
  'guardians.title': 'Acudientes',
  'guardians.caption': 'Acudientes del colegio',
  'guardians.new': 'Nuevo acudiente',
  'guardians.edit': 'Editar acudiente',
  'guardians.search.help': 'Nombre, correo o número de documento.',
  'guardians.empty.title': 'Sin acudientes',
  'guardians.empty.body': 'Cree el primero o impórtelos desde la plantilla de acudientes.',
  'guardians.column.name': 'Acudiente',
  'guardians.column.students': 'Estudiantes',
  'guardians.column.invitation': 'Invitación',
  'guardians.total': '{total} acudientes',
  'guardian.field.email.help': 'Es su acceso a la app; con él se le puede invitar.',
  'link.add': 'Vincular acudiente',
  'link.edit': 'Editar vínculo',
  'link.remove': 'Desvincular',
  'link.remove.body': '¿Desvincular a {name}? La persona sigue existiendo como acudiente.',
  'link.search': 'Buscar acudiente',
  'link.search.help': 'Escriba al menos dos letras del nombre, correo o documento.',
  'link.selected': 'Seleccionado: {name}',
  'link.students': '{count} estudiantes',
  'link.none': 'Nadie con esos datos. Puede crearlo.',
  'link.create': 'Crear acudiente nuevo',
  'link.creating': 'Complete los datos del nuevo acudiente; luego defina el vínculo.',
  'link.created': 'acudiente nuevo',
  'link.pick': 'Seleccione o cree un acudiente.',
  'link.submit': 'Vincular',
  'link.relationship': 'Parentesco',
  'link.relationship.help': 'madre, padre, abuela, tío, acudiente…',
  'link.primary.help': 'A quién se llama primero.',
  'link.billing.help': 'A quién se le cobra.',
  'invite.action': 'Invitar',
  'invite.resend': 'Reenviar invitación',
  'invite.sent': 'Invitación enviada',
  'invite.noEmail': 'Sin correo: no se puede invitar.',
  'invite.status.none': 'Sin invitación',
  'invite.status.pending': 'Invitación pendiente',
  'invite.status.accepted': 'Con acceso',
  'invite.status.expired': 'Invitación vencida',
  'invite.status.revoked': 'Invitación reemplazada',
  'sensitive.title': 'Datos sensibles',
  'sensitive.notice':
    'Salud, religión y etnia. Cada lectura queda en la auditoría; requiere consentimiento vigente de la familia.',
  'sensitive.noConsent': 'La familia no ha autorizado el tratamiento de datos sensibles.',
  'sensitive.edit': 'Editar',
  'sensitive.field.eps': 'EPS',
  'sensitive.field.allergies': 'Alergias',
  'sensitive.field.disabilities': 'Discapacidades o condiciones',
  'sensitive.field.religion': 'Religión',
  'sensitive.field.ethnicity': 'Etnia',
  'consent.capture': 'Registrar consentimiento',
  'consent.submit': 'Registrar',
  'consent.purposes': 'Finalidades autorizadas',
  'consent.purpose.general': 'Tratamiento general de datos',
  'consent.purpose.sensitive': 'Datos sensibles (salud, religión, etnia)',
  'consent.purpose.ai': 'MentorIA (inteligencia artificial)',
  'consent.purpose.notice': 'Aviso de privacidad',
  'consents.title': 'Textos de consentimiento',
  'consents.intro': `Estos son los textos que ven y aceptan las familias: el aviso de privacidad y las autorizaciones de datos. ${PRODUCT_NAME} trae una versión revisada según la Ley 1581 de 2012; puede ajustarla a su colegio. Cada cambio se publica como una versión nueva y las autorizaciones ya firmadas conservan el texto que aceptaron.`,
  'consents.version': 'Versión {version}',
  'consents.default': `Texto de ${PRODUCT_NAME}`,
  'consents.own': 'Texto del colegio',
  'consents.read': 'Leer el texto',
  'consents.edit': 'Editar texto',
  'consents.editFor': 'Editar {title}',
  'consents.publish': 'Publicar versión',
  'consents.newVersion':
    'Al publicar se crea la versión {version}. Las familias que ya autorizaron conservan la versión que firmaron; las nuevas autorizaciones usarán esta.',
  'consents.field.title': 'Título',
  'consents.field.body': 'Texto',
  'consents.field.body.help':
    'Escriba {{schoolName}} donde deba ir el nombre del colegio; se reemplaza al mostrarlo. Mínimo 50 caracteres.',
  'consents.published': 'Versión {version} publicada.',
  'consent.textVersion': '{title} · versión {version}',
  'consent.channel': 'Canal',
  'consent.channel.app': 'Autorizó desde la app',
  'consent.channel.onboarding': 'Autorizó en la matrícula',
  'consent.channel.paper': 'Formato en papel (adjuntar escaneado)',
  'consent.authorizedBy': 'Quién autoriza',
  'consent.noGuardians': 'Vincule un acudiente primero',
  'consent.signerName': 'Nombre de quien firma',
  'consent.signerDocument': 'Documento de quien firma',
  'consent.evidence': 'Formato firmado',
  'consent.evidence.help': 'PDF o imagen del consentimiento firmado.',
  'consent.upload.error': 'No se pudo subir el formato.',
  'teachers.new': 'Nuevo docente',
  'teacher.edit': 'Editar',
  'teacher.back': 'Volver a docentes',
  'teacher.notFound': 'No encontramos a ese docente.',
  'teacher.field.email.help': 'Es su acceso; con él se le invita.',
  'assignments.title': 'Grupos y asignaturas este año',
  'assignments.empty': 'Sin asignaciones todavía.',
  'assignments.edit': 'Editar asignaciones',
  'assignments.year': 'Asignaciones del año lectivo {year}. Se reemplazan todas al guardar.',
  'assignments.group': 'Grupo',
  'assignments.subject': 'Asignatura',
  'assignments.homeroom': 'Dirección de grupo',
  'assignments.homeroomOnly': 'Solo dirección de grupo',
  'assignments.pick': 'Seleccione…',
  'assignments.add': 'Agregar asignación',
  'assignments.remove': 'Quitar',
  'assignments.incomplete': 'Cada fila necesita grupo y asignatura (o dirección de grupo).',
  'access.denied.title': 'No tiene acceso a esta pantalla',
  'access.denied.body':
    'Su cargo no incluye este permiso. Si lo necesita, la rectoría puede dárselo desde Usuarios.',
  'access.denied.home': 'Volver al inicio',
  'nav.admin': 'Administración',
  'nav.users': 'Usuarios',
  'nav.roles': 'Plantillas de permisos',
  'nav.consents': 'Consentimientos',
  'imports.placement.title': 'Filas sin ubicar',
  'imports.placement.intro':
    'Estas filas nombran un grupo o un año que el colegio todavía no tiene. Decida qué hacer con cada grupo: la revisión se repite sola y nada se guarda hasta que importe.',
  'imports.placement.rerunning': 'Revisando el archivo con sus decisiones…',
  'imports.placement.noYear':
    'Las filas {lines} no dicen el año lectivo y el colegio no tiene uno activo.',
  'imports.placement.year': 'Año lectivo para esas filas',
  'imports.placement.activate': 'O active un año en Años escolares',
  'imports.placement.choose': 'Elegir…',
  'imports.placement.grade': 'grado {grade}',
  'imports.placement.rows': 'filas {lines}',
  'imports.placement.what': 'Qué hacer con {name}',
  'imports.placement.create': 'Crear el grupo {name}',
  'imports.placement.assign': 'Asignar a {name}',
  'imports.placement.none': 'Importar sin grupo (matricular después)',
  'imports.placement.decisions': 'Decisiones para este archivo',
  'imports.placement.decision.year': 'Filas sin año → {year}',
  'imports.placement.decision.assign': '{from} → {to}',
  'imports.placement.decision.none': '{from} → sin grupo',
  'imports.placement.undo': 'Deshacer',
  'imports.placement.undoFor': 'Deshacer la decisión de {name}',
  'imports.placement.createTitle': 'Crear el grupo {name}',
  'imports.placement.inYear': 'El grupo se crea en el año lectivo {year}.',
  'imports.placement.field.name': 'Nombre del grupo',
  'imports.placement.field.grade': 'Grado',
  'imports.placement.newGrade': 'Nuevo grado: {name}',
  'imports.placement.field.gradeName': 'Nombre del grado',
  'imports.placement.field.level': 'Nivel del grado nuevo',
  'imports.placement.newLevel': 'Nuevo nivel',
  'imports.placement.field.levelName': 'Nombre del nivel',
  'imports.placement.field.levelName.help': 'Por ejemplo Básica Primaria.',
  'imports.placement.field.sede': 'Sede',
  'imports.placement.field.jornada': 'Jornada',
  'imports.placement.submit': 'Crear grupo',
  'imports.placement.created': 'Grupo {name} creado.',
  'users.title': 'Usuarios del colegio',
  'users.caption': 'Personas que administran el colegio',
  'users.intro':
    'Quiénes entran a administrar el colegio y qué puede hacer cada quien. Docentes y acudientes se invitan desde su ficha.',
  'users.new': 'Nuevo usuario',
  'users.search.help': 'Nombre o correo.',
  'users.empty.title': 'Solo la rectoría tiene acceso',
  'users.empty.body': 'Cree a la secretaria, la coordinación y a quien más administre el colegio.',
  'users.column.person': 'Persona',
  'users.column.role': 'Rol',
  'users.column.templates': 'Plantillas',
  'users.column.access': 'Acceso',
  'users.column.overrides': 'Excepciones',
  'users.role.SCHOOL_OWNER': 'Rectoría',
  'users.role.SCHOOL_STAFF': 'Personal',
  'users.status.active': 'Con acceso',
  'users.status.invited': 'Invitación pendiente',
  'users.status.no-account': 'Sin cuenta',
  'users.status.disabled': 'Deshabilitado',
  'users.templates.none': 'Sin plantilla',
  'users.overrides.count': '{count} excepciones',
  'users.field.givenName': 'Nombres',
  'users.field.familyName': 'Apellidos',
  'users.field.email': 'Correo',
  'users.field.email.help': 'Es su acceso: la invitación llega a este correo.',
  'users.field.templates': 'Plantillas de permisos',
  'users.field.templates.help':
    'Lo que la persona puede hacer. Se pueden combinar; las excepciones se ajustan después desde su ficha.',
  'users.create.submit': 'Crear e invitar',
  'users.created': 'Usuario creado e invitado',
  'users.detail.title': 'Acceso de {name}',
  'users.detail.rename': 'Editar nombre',
  'users.detail.disable': 'Deshabilitar acceso',
  'users.detail.disable.body':
    '¿Deshabilitar a {name}? No podrá entrar; su historia y sus registros se conservan. Se puede reactivar.',
  'users.detail.enable': 'Reactivar acceso',
  'users.detail.templates': 'Plantillas',
  'users.detail.templates.save': 'Guardar plantillas',
  'users.detail.templates.saved': 'Plantillas guardadas',
  'users.detail.overrides': 'Excepciones para esta persona',
  'users.detail.overrides.help':
    'Un permiso que sus plantillas no traen, o uno que se le quita solo a ella. Cada permiso muestra de dónde sale.',
  'users.detail.overrides.save': 'Guardar excepciones',
  'users.detail.overrides.saved': 'Excepciones guardadas',
  'users.detail.effective': 'Permisos que resultan',
  'users.detail.effective.all': 'Acceso completo: la rectoría tiene todos los permisos.',
  'users.detail.effective.count': '{count} permisos',
  'users.source.template': 'De la plantilla',
  'users.source.added': 'Agregado',
  'users.source.removed': 'Quitado',
  'users.source.none': 'No lo tiene',
  'users.updated': 'Usuario actualizado',
  'roles.title': 'Plantillas de permisos',
  'roles.caption': 'Plantillas del colegio',
  'roles.intro': `Una plantilla reúne lo que un cargo puede hacer. Las que trae ${PRODUCT_NAME} se copian; las del colegio se editan y se borran cuando nadie las usa.`,
  'roles.new': 'Nueva plantilla',
  'roles.empty.title': 'Sin plantillas',
  'roles.empty.body': `Cree la primera o copie una de las que trae ${PRODUCT_NAME}.`,
  'roles.column.name': 'Plantilla',
  'roles.column.permissions': 'Permisos',
  'roles.column.users': 'Personas',
  'roles.default': `De ${PRODUCT_NAME}`,
  'roles.permissions.count': '{count} permisos',
  'roles.users.count': '{count} personas',
  'roles.edit': 'Editar',
  'roles.copy': 'Duplicar',
  'roles.copy.name': '{name} (copia)',
  'roles.delete': 'Eliminar',
  'roles.delete.body': '¿Eliminar la plantilla "{name}"? Nadie la tiene puesta.',
  'roles.deleted': 'Plantilla eliminada',
  'roles.field.name': 'Nombre',
  'roles.field.description': 'Descripción',
  'roles.field.description.help': 'Para quién es, en una línea.',
  'roles.field.permissions': 'Permisos',
  'roles.inUse.warning':
    '{count} personas tienen esta plantilla: el cambio les aplica en su próxima acción.',
  'roles.saved': 'Plantilla guardada',
  'roles.created': 'Plantilla creada',
  'roles.group.all': 'Todo el grupo',
  'resource.tenant': 'Colegio',
  'resource.sedes': 'Sedes',
  'resource.users': 'Usuarios',
  'resource.roles': 'Plantillas de permisos',
  'resource.permissions': 'Excepciones por persona',
  'resource.academic': 'Años, periodos, niveles, grados y grupos',
  'resource.subjects': 'Asignaturas',
  'resource.classrooms': 'Aulas',
  'resource.students': 'Estudiantes',
  'resource.guardians': 'Acudientes',
  'resource.teachers': 'Docentes',
  'resource.curriculum': 'Plan de estudios',
  'resource.classlog': 'Bitácora de clase',
  'resource.timetable': 'Horario',
  'resource.attendance': 'Asistencia',
  'resource.grades': 'Calificaciones',
  'resource.assignments': 'Tareas',
  'resource.communication': 'Comunicados',
  'resource.billing': 'Cobros',
  'resource.imports': 'Importación de datos',
  'resource.consents': 'Consentimientos',
  'resource.audit': 'Bitácora de acceso',
  'resource.reports': 'Reportes y exportaciones',
  'resource.mentoria': 'MentorIA',
  'permission.tenant:read': 'Ver la configuración del colegio',
  'permission.tenant:write': 'Editar la configuración del colegio',
  'permission.sedes:read': 'Ver las sedes',
  'permission.sedes:write': 'Crear y editar sedes',
  'permission.users:read': 'Ver quién administra el colegio',
  'permission.users:write': 'Crear y editar usuarios del colegio',
  'permission.users:invite': 'Invitar personas (docentes, acudientes, personal)',
  'permission.roles:read': 'Ver las plantillas de permisos',
  'permission.roles:write': 'Crear y editar plantillas de permisos',
  'permission.permissions:write': 'Poner excepciones de permisos a una persona',
  'permission.academic:read': 'Ver años, periodos, niveles, grados y grupos',
  'permission.academic:write': 'Crear y editar años, periodos, niveles, grados y grupos',
  'permission.subjects:read': 'Ver las asignaturas',
  'permission.subjects:write': 'Crear y editar asignaturas',
  'permission.classrooms:read': 'Ver las aulas',
  'permission.classrooms:write': 'Crear y editar aulas',
  'permission.students:read': 'Ver estudiantes',
  'permission.students:write': 'Crear, editar y matricular estudiantes',
  'permission.students:sensitive': 'Ver datos sensibles (salud, religión, etnia)',
  'permission.guardians:read': 'Ver acudientes',
  'permission.guardians:write': 'Crear, editar y vincular acudientes',
  'permission.teachers:read': 'Ver docentes',
  'permission.teachers:write': 'Crear y editar docentes y sus asignaciones',
  'permission.curriculum:read': 'Ver el plan de estudios',
  'permission.curriculum:write': 'Editar el plan de estudios',
  'permission.classlog:read': 'Ver la bitácora de clase',
  'permission.classlog:write': 'Registrar lo que se cubrió en clase',
  'permission.timetable:read': 'Ver el horario',
  'permission.timetable:write': 'Editar el horario',
  'permission.attendance:read': 'Ver la asistencia',
  'permission.attendance:write': 'Marcar asistencia',
  'permission.grades:read': 'Ver evaluaciones y notas',
  'permission.grades:write': 'Registrar evaluaciones y notas',
  'permission.grades:publish': 'Publicar notas y boletines',
  'permission.assignments:read': 'Ver las tareas de cualquier grupo y sus entregas',
  'permission.assignments:write': 'Crear, editar, cerrar y revisar tareas de cualquier grupo',
  'permission.communication:read': 'Ver comunicados',
  'permission.communication:write': 'Publicar comunicados',
  'permission.billing:read': 'Ver cargos, estados de cuenta y pagos',
  'permission.billing:write': 'Generar cargos y registrar pagos',
  'permission.billing:configure': 'Configurar conceptos y tarifas',
  'permission.imports:run': 'Importar datos desde las plantillas CSV',
  'permission.consents:read': 'Ver los consentimientos',
  'permission.audit:read': 'Ver la bitácora de acceso a datos',
  'permission.reports:read': 'Ver tableros y exportaciones',
  'permission.mentoria:use': 'Abrir sesiones de MentorIA',
  'nav.curriculum': 'Plan de estudios',
  'curriculum.title': 'Plan de estudios',
  'curriculum.grade': 'Grado',
  'curriculum.subject': 'Asignatura',
  'curriculum.topicsCount': '{count} temas',
  'curriculum.subjects.edit': 'Asignaturas del grado',
  'curriculum.subjects.empty':
    'Este grado no tiene asignaturas todavía; defínalas para armar el plan.',
  'curriculum.weeklyHours': 'Horas/semana',
  'curriculum.plan': 'Temas y logros por periodo',
  'curriculum.plan.empty':
    'El plan está vacío. Siémbrelo desde los DBA y edítelo, o agregue temas periodo por periodo.',
  'curriculum.period': 'Periodo {period}',
  'curriculum.seed': 'Sembrar desde los DBA',
  'curriculum.seed.help': `${PRODUCT_NAME} propone un tema con su logro por periodo, en sus propias palabras y con la referencia al DBA del área y grado. Desmarque lo que no quiera.`,
  'curriculum.seed.none': `${PRODUCT_NAME} no trae semilla para esta asignatura y grado: cubre Matemáticas, Lenguaje, Ciencias Naturales, Ciencias Sociales e Inglés de Transición a Undécimo. Escriba el plan tema por tema.`,
  'curriculum.seed.grade': `${PRODUCT_NAME} no reconoce este grado como un grado nacional (Transición a Undécimo); siembre otro grado o escriba el plan.`,
  'curriculum.seed.confirm': 'Sembrar {count} temas',
  'curriculum.topic.add': 'Agregar tema',
  'curriculum.topic.edit': 'Editar',
  'curriculum.topic.delete': 'Eliminar tema',
  'curriculum.topic.delete.body':
    '¿Eliminar "{title}"? Las clases registradas con este tema conservan su nota.',
  'curriculum.topic.title': 'Tema',
  'curriculum.topic.period': 'Periodo',
  'curriculum.topic.logros': 'Logros',
  'curriculum.topic.logros.help': 'Uno por línea.',
  'curriculum.topic.dba': 'Referencia DBA (opcional)',
  'curriculum.source.dba': 'DBA',
  'curriculum.source.school': 'Colegio',
  'curriculum.reorder': 'Reordenar',
  'curriculum.up': 'Subir',
  'curriculum.down': 'Bajar',
  'announcements.tab.feed': 'Publicados',
  'announcements.tab.manage': 'Gestionar',
  'announcements.manage.edit': 'Editar',
  'announcements.recipients.name': 'Destinatario',
  'announcements.manage.title': 'Comunicados del colegio',
  'announcements.manage.caption': 'Comunicados con su estado',
  'announcements.manage.empty.title': 'Sin comunicados',
  'announcements.manage.empty.body':
    'Escriba el primero: llega a las familias por la app y por correo.',
  'announcements.filter.status': 'Estado',
  'announcements.filter.audience': 'Audiencia',
  'announcements.column.when': 'Cuándo',
  'announcements.column.reach': 'Lecturas',
  'announcements.column.reach.value': '{read} de {total} leídos · {emailed} correos',
  'announcements.detail.reach':
    '{total} destinatarios · {read} leídos · {emailed} correos enviados',
  'announcements.detail.attachments': '{count} adjuntos',
  'announcements.detail.recipients': 'Destinatarios y recibos',
  'announcements.detail.noRecipients': 'Sin destinatarios (no publicado o audiencia vacía).',
  'announcements.detail.email': 'Correo',
  'announcements.detail.read': 'Lectura',
  'announcements.delivery.sent': 'Enviado',
  'announcements.delivery.pending': 'En cola',
  'announcements.delivery.unread': 'Sin leer',
  'announcement.new': 'Nuevo comunicado',
  'announcement.edit': 'Editar comunicado',
  'announcement.publish': 'Publicar',
  'announcement.archive': 'Archivar',
  'announcement.archive.body': '¿Archivar "{title}"? Deja de mostrarse; los recibos se conservan.',
  'announcement.field.title': 'Título',
  'announcement.field.body': 'Mensaje',
  'announcement.field.audience': 'Audiencia',
  'announcement.field.attachments': 'Adjuntos',
  'announcement.field.attachments.help': 'PDF o imágenes; solo los destinatarios pueden abrirlos.',
  'announcement.field.mode': 'Publicación',
  'announcement.field.scheduledAt': 'Publicar el',
  'announcement.audience.all': 'Todo el colegio',
  'announcement.audience.sede': 'Una sede',
  'announcement.audience.grade': 'Un grado',
  'announcement.audience.group': 'Un grupo',
  'announcement.audience.family': 'Una familia',
  'announcement.target.sede': 'Sede',
  'announcement.target.grade': 'Grado',
  'announcement.target.group': 'Grupo',
  'announcement.target.family': 'Estudiante',
  'announcement.target.family.help': 'Busque al estudiante; el comunicado llega a sus acudientes.',
  'announcement.mode.draft': 'Guardar como borrador',
  'announcement.mode.now': 'Publicar ahora',
  'announcement.mode.schedule': 'Programar',
  'announcement.submit.draft': 'Guardar borrador',
  'announcement.submit.now': 'Publicar',
  'announcement.submit.schedule': 'Programar',
  'announcement.frozen': 'Publicado: la audiencia y la programación ya no cambian.',
  'announcement.status.draft': 'Borrador',
  'announcement.status.scheduled': 'Programado',
  'announcement.status.published': 'Publicado',
  'announcement.status.archived': 'Archivado',
  'announcement.saved.draft': 'Borrador guardado',
  'announcement.saved.scheduled': 'Comunicado programado',
  'announcement.saved.published': 'Comunicado publicado',
  'announcement.saved.archived': 'Comunicado archivado',
  'announcement.error.target': 'Elija el destino de la audiencia.',
  'announcement.error.family': 'Elija al estudiante.',
  'announcement.error.schedule': 'Indique cuándo publicar.',
  'nav.billing': 'Cobros',
  'billing.title': 'Cobros',
  'billing.back': 'Volver a cobros',
  'billing.tab.families': 'Familias',
  'billing.tab.concepts': 'Conceptos y tarifas',
  'billing.tab.generate': 'Generar cargos',
  'billing.tab.export': 'Exportar',
  'billing.tab.calendar': 'Calendario',
  'billing.tab.reminders': 'Recordatorios',
  'billing.calendar.title': 'Calendario de cobros {year}',
  'billing.calendar.intro':
    'Cada concepto recurrente cobra los meses marcados y vence el día elegido. El día 1 de cada mes a las 7:00 el trabajo genera el mes en curso; aquí se ve cuántos cargos tiene cada mes.',
  'billing.calendar.caption': 'Calendarios de los conceptos recurrentes',
  'billing.calendar.empty.title': 'Sin conceptos recurrentes',
  'billing.calendar.empty.body':
    'Cree la pensión como concepto recurrente en "Conceptos y tarifas" y vuelva aquí.',
  'billing.calendar.column.concept': 'Concepto',
  'billing.calendar.column.dueDay': 'Vence el día',
  'billing.calendar.column.months': 'Meses',
  'billing.calendar.notConfigured': 'Sin calendario',
  'billing.calendar.disabled': 'Deshabilitado',
  'billing.calendar.enabled': 'Habilitado',
  'billing.calendar.month.generated': '{month}: {count} cargos',
  'billing.calendar.month.generatedOne': '{month}: 1 cargo',
  'billing.calendar.month.pending': '{month}: sin generar',
  'billing.calendar.edit': 'Calendario de {name}',
  'billing.calendar.field.enabled': 'Habilitado',
  'billing.calendar.field.enabled.help':
    'Deshabilitado, el trabajo del día 1 no genera este concepto; los meses se conservan.',
  'billing.calendar.field.dueDay': 'Día de vencimiento',
  'billing.calendar.field.dueDay.help': 'Del 1 al 28, para que exista en todos los meses.',
  'billing.calendar.field.months': 'Meses que se cobran',
  'billing.calendar.field.months.help': 'Los meses del año lectivo; marque los que llevan cobro.',
  'billing.calendar.allMonths': 'Marcar todos',
  'billing.calendar.noMonths': 'Marque al menos un mes.',
  'billing.calendar.saved': 'Calendario guardado',
  'billing.run.title': 'Correr un mes',
  'billing.run.intro':
    'La misma generación del trabajo del día 1, para un mes que no se generó o que se quiere adelantar: primero la vista previa, luego la confirmación. Repetirla no duplica cargos.',
  'billing.run.month': 'Mes',
  'billing.run.concept': 'Concepto',
  'billing.run.allConcepts': 'Todos los habilitados',
  'billing.run.caption': 'Resultado por concepto',
  'billing.run.column.concept': 'Concepto',
  'billing.run.nothing': 'Ningún calendario habilitado cobra ese mes.',
  'billing.reminders.title': 'Recordatorios de cobro',
  'billing.reminders.intro':
    'Cada día a las 7:00 el colegio avisa a los acudientes en la bandeja de la app: "Cobro por vencer" desde los días antes del vencimiento y "Cobro vencido" desde los días después. Un aviso por cargo y etapa; el trabajo no repite.',
  'billing.reminders.before': 'Días antes del vencimiento',
  'billing.reminders.before.help': 'De 0 a 30; con 0, solo el día del vencimiento.',
  'billing.reminders.after': 'Días después del vencimiento',
  'billing.reminders.after.help': 'De 1 a 30.',
  'billing.reminders.default': 'Valores por defecto (3 días antes y 1 después).',
  'billing.reminders.custom': 'Valores propios del colegio.',
  'billing.reminders.saved': 'Recordatorios guardados',
  'billing.families.title': 'Estados de cuenta por familia',
  'billing.families.caption': 'Familias con su saldo',
  'billing.families.search.help': 'Nombre, correo o documento del acudiente.',
  'billing.families.withBalance': 'Solo con saldo',
  'billing.families.empty.title': 'Sin familias con cuenta',
  'billing.families.empty.body': 'Las cuentas aparecen al generar cargos o registrar un saldo.',
  'billing.families.column.guardian': 'Acudiente responsable',
  'billing.families.column.students': 'Estudiantes',
  'billing.families.column.balance': 'Saldo',
  'billing.families.column.overdue': 'Vencido',
  'billing.concepts.title': 'Conceptos del año {year}',
  'billing.concepts.caption': 'Conceptos de cobro',
  'billing.concepts.new': 'Nuevo concepto',
  'billing.concepts.empty.title': 'Sin conceptos',
  'billing.concepts.empty.body': 'Cree la matrícula y la pensión con sus tarifas por grado.',
  'billing.concepts.column.name': 'Concepto',
  'billing.concepts.column.tariffs': 'Tarifas',
  'billing.concepts.noTariffs': 'Sin tarifas',
  'billing.concepts.recurring': 'Recurrente',
  'billing.concepts.recurring.help': 'Se cobra cada periodo (pensión, transporte, alimentación).',
  'billing.concepts.field.code': 'Tipo',
  'billing.concepts.field.name': 'Nombre',
  'billing.concepts.field.name.help':
    'Como aparecerá en el estado de cuenta, por ejemplo "Matrícula 2027".',
  'billing.code.matricula': 'Matrícula',
  'billing.code.pension': 'Pensión',
  'billing.code.transporte': 'Transporte',
  'billing.code.alimentacion': 'Alimentación',
  'billing.code.otro': 'Otro',
  'billing.tariffs.title': 'Tarifas de {name}',
  'billing.tariffs.allGrades': 'Todos los grados',
  'billing.tariffs.general': 'Tarifa general',
  'billing.tariffs.general.help':
    'Aplica a los grados sin tarifa propia. Deje vacío lo que no aplica.',
  'billing.generate.title': 'Generar cargos',
  'billing.generate.intro':
    'Un cargo por estudiante matriculado en el año del concepto, en la cuenta de su acudiente responsable, con la tarifa de su grado y sus descuentos vigentes. Primero vea la vista previa.',
  'billing.generate.concept': 'Concepto',
  'billing.generate.grade': 'Grado',
  'billing.generate.allGrades': 'Todos los grados',
  'billing.generate.dueOn': 'Fecha de vencimiento',
  'billing.generate.period': 'Periodo',
  'billing.generate.period.help':
    '2027 para la matrícula, 2027-02 para la pensión de febrero. Generar dos veces el mismo periodo no duplica.',
  'billing.generate.preview': 'Vista previa',
  'billing.generate.confirm': 'Generar {count} cargos',
  'billing.generate.done': 'Cargos generados',
  'billing.generate.summary': '{created} creados, {skipped} ya existían · {total}',
  'billing.generate.totals.created': 'Se crearían',
  'billing.generate.totals.skipped': 'Ya existen',
  'billing.generate.totals.withoutFamily': 'Sin acudiente',
  'billing.generate.totals.total': 'Total',
  'billing.generate.withoutFamily': 'Sin acudiente responsable (no se les puede cobrar): {names}',
  'billing.generate.previewCaption': 'Cargos que se crearían',
  'billing.export.title': 'Exportar para facturación',
  'billing.export.intro':
    'Cargos o pagos de un periodo con la identidad del acudiente, en CSV (Excel lo abre) o Excel.',
  'billing.export.kind': 'Qué exportar',
  'billing.export.charges': 'Cargos por fecha de vencimiento',
  'billing.export.payments': 'Pagos por fecha de pago',
  'billing.export.from': 'Desde',
  'billing.export.to': 'Hasta',
  'billing.export.csv': 'Descargar CSV',
  'billing.export.xlsx': 'Descargar Excel',
  'billing.statement.title': 'Estado de cuenta',
  'billing.statement.students': 'Estudiantes: {names}',
  'billing.statement.totals.charged': 'Cobrado',
  'billing.statement.totals.discounts': 'Descuentos',
  'billing.statement.totals.paid': 'Pagado',
  'billing.statement.totals.credit': 'Saldo a favor',
  'billing.statement.totals.balance': 'Saldo',
  'billing.statement.charges': 'Cargos',
  'billing.statement.charges.empty': 'Sin cargos',
  'billing.statement.payments': 'Pagos',
  'billing.statement.payments.empty': 'Sin pagos',
  'billing.statement.column.description': 'Concepto',
  'billing.statement.column.dueOn': 'Vence',
  'billing.statement.column.amount': 'Valor',
  'billing.statement.column.discount': 'Descuento',
  'billing.statement.column.balance': 'Saldo',
  'billing.statement.column.status': 'Estado',
  'billing.statement.column.invoice': 'Factura',
  'billing.statement.column.paidOn': 'Fecha',
  'billing.statement.column.method': 'Medio',
  'billing.statement.column.reference': 'Recibo / referencia',
  'billing.statement.column.allocated': 'Aplicado',
  'billing.charge.status.pending': 'Pendiente',
  'billing.charge.status.partial': 'Parcial',
  'billing.charge.status.paid': 'Pagado',
  'billing.charge.status.void': 'Anulado',
  'billing.method.cash': 'Efectivo',
  'billing.method.transfer': 'Transferencia',
  'billing.method.gateway': 'Pasarela',
  'billing.method.opening': 'Saldo inicial',
  'billing.payment.record': 'Registrar pago',
  'billing.payment.for': 'Pago de {description} (saldo {balance}).',
  'billing.payment.oldestFirst':
    'Sin cargo elegido, el pago se aplica al cargo vencido más antiguo primero.',
  'billing.payment.amount': 'Valor',
  'billing.payment.paidOn': 'Fecha de pago',
  'billing.payment.method': 'Medio',
  'billing.payment.receipt': 'Número de recibo',
  'billing.payment.receipt.help': 'El recibo de caja que se entrega a la familia.',
  'billing.payment.reference': 'Referencia (transferencia)',
  'billing.payment.submit': 'Registrar',
  'billing.link.title': 'Enlace de pago',
  'billing.link.copy': 'Copiar enlace de pago',
  'billing.link.copied': 'Enlace de pago copiado',
  'billing.link.expires': 'Vale hasta el {date}; compártalo con la familia.',
  'students.title': 'Estudiantes',
  'students.caption': 'Estudiantes del colegio',
  'students.empty.title': 'Sin estudiantes',
  'students.empty.body': 'Con estos filtros no hay estudiantes.',
  'students.filter.grade': 'Grado',
  'students.filter.group': 'Grupo',
  'students.filter.search': 'Buscar',
  'students.filter.search.help': 'Nombre, apellido o número de documento.',
  'students.filter.all': 'Todos',
  'students.column.name': 'Estudiante',
  'students.column.document': 'Documento',
  'students.column.group': 'Grupo',
  'students.column.status': 'Estado',
  'students.total': '{total} estudiantes',
  'students.page': 'Página {page} de {pages}',
  'students.prev': 'Anterior',
  'students.next': 'Siguiente',
  'student.title': 'Estudiante',
  'student.back': 'Volver a estudiantes',
  'student.identity': 'Identidad',
  'student.field.document': 'Documento',
  'student.field.birthDate': 'Fecha de nacimiento',
  'student.field.email': 'Correo',
  'student.field.status': 'Estado',
  'student.enrollment': 'Matrícula {year}',
  'student.enrollment.planned': 'Matrícula {year} (año planeado, aún no activo)',
  'students.year.planned':
    'El colegio no tiene un año lectivo activo. Los grupos que se ven son los del año {year}, que está planeado; cuando empiece el año, actívelo.',
  'students.year.none':
    'El colegio todavía no tiene año lectivo, así que ningún estudiante tiene grupo. Cree el año y matricule a los estudiantes.',
  'students.year.activate': 'Ir al año {year}',
  'students.year.create': 'Ir a Años escolares',
  'student.field.group': 'Grupo',
  'student.field.grade': 'Grado',
  'student.field.enrolledOn': 'Matriculado el',
  'student.guardians': 'Acudientes',
  'student.guardians.empty': 'Sin acudientes registrados.',
  'student.guardian.primary': 'Contacto principal',
  'student.guardian.billing': 'Responsable de pago',
  'student.reportCard': 'Ver boletín',
  'student.reportCards': 'Boletines',
  'student.reportCards.empty': 'El año no tiene periodos todavía.',
  'student.reportCards.published': '{count} asignaturas publicadas',
  'student.reportCards.none': 'Sin notas publicadas',
  'student.reportCards.generated': 'PDF generado el {date}',
  'student.reportCards.notGenerated': 'PDF sin generar: se genera al descargarlo.',
  'student.reportCards.download': 'Descargar PDF',
  'student.reportCards.download.aria': 'Descargar el boletín de {period}',
  'student.status.active': 'Activo',
  'student.status.withdrawn': 'Retirado',
  'student.status.graduated': 'Graduado',
  'teachers.title': 'Docentes',
  'teachers.caption': 'Docentes del colegio',
  'teachers.empty.title': 'Sin docentes',
  'teachers.empty.body': 'Cree el primer docente o impórtelos desde una plantilla.',
  'teachers.column.name': 'Docente',
  'teachers.column.homeroom': 'Dirección de grupo',
  'teachers.column.subjects': 'Asignaturas',
  'teachers.column.groups': 'Grupos',
  'timetable.title': 'Horario semanal',
  'timetable.views': 'Vistas del horario',
  'timetable.view.group': 'Por grupo',
  'timetable.view.teacher': 'Por docente',
  'timetable.view.classroom': 'Por aula',
  'timetable.filter.year': 'Año lectivo',
  'timetable.filter.group': 'Grupo',
  'timetable.filter.teacher': 'Docente',
  'timetable.filter.classroom': 'Aula',
  'timetable.grid.time': 'Hora',
  'timetable.empty': 'Este grupo no tiene horario.',
  'timetable.empty.build': 'Agregue el primer bloque o copie el horario de otro grupo.',
  'timetable.empty.teacher': 'Este docente no tiene clases en el horario de este año.',
  'timetable.empty.classroom': 'Esta aula no tiene clases en el horario de este año.',
  'timetable.day.1': 'Lunes',
  'timetable.day.2': 'Martes',
  'timetable.day.3': 'Miércoles',
  'timetable.day.4': 'Jueves',
  'timetable.day.5': 'Viernes',
  'timetable.day.6': 'Sábado',
  'timetable.day.7': 'Domingo',
  'timetable.noYear': 'Cree un año lectivo primero.',
  'timetable.noGroup': 'Cree un grupo de esta sede en ese año lectivo primero.',
  'timetable.noTeacher': 'Cree un docente primero.',
  'timetable.noClassroom': 'Cree un aula de esta sede primero.',
  'timetable.teacher.week': 'Semana de {name}',
  'timetable.classroom.week': 'Ocupación de {name}',
  'timetable.hint':
    'Haga clic en un bloque para moverlo, cambiarlo o quitarlo; en una celda vacía, para agregar uno a esa hora.',
  'timetable.add': 'Agregar bloque',
  'timetable.add.at': 'Agregar bloque el {day} a las {time}',
  'timetable.edit': 'Editar bloque',
  'timetable.edit.of': 'Editar {subject} del {day} a las {time}',
  'timetable.form.group': 'Semana de {group}',
  'timetable.delete': 'Quitar del horario',
  'timetable.delete.title': '¿Quitar el bloque?',
  'timetable.delete.body':
    'Se quitará {subject} del {day} de {start} a {end}. La asistencia y la bitácora que lo mencionan conservan su grupo y su fecha.',
  'timetable.deleted': 'Bloque quitado.',
  'timetable.created': 'Bloque agregado.',
  'timetable.saved': 'Bloque guardado.',
  'timetable.saveAndNext': 'Guardar y agregar otro',
  'timetable.incomplete': 'Elija la asignatura.',
  'timetable.hours': 'La hora de fin debe ser posterior a la de inicio.',
  'timetable.field.subject': 'Asignatura',
  'timetable.field.teacher': 'Docente',
  'timetable.field.teacher.help': 'Primero los docentes con esta asignatura asignada en el grupo.',
  'timetable.field.teacher.none': 'Sin docente por ahora',
  'timetable.field.teacher.assigned': '— Con la asignación —',
  'timetable.field.teacher.others': '— Otros docentes —',
  'timetable.field.classroom': 'Aula',
  'timetable.field.classroom.none': 'Sin aula por ahora',
  'timetable.field.weekday': 'Día',
  'timetable.field.startsAt': 'Inicio',
  'timetable.field.endsAt': 'Fin',
  'timetable.conflict.group': 'El grupo ya tiene clase',
  'timetable.conflict.teacher': 'El docente ya dicta',
  'timetable.conflict.classroom': 'El aula está ocupada',
  'timetable.conflict.block': '{subject} · {group} · {day} {start}–{end}',
  'timetable.conflict.hint':
    'Cambie el día, la hora, el docente o el aula y vuelva a guardar; lo escrito se conserva.',
  'timetable.copy': 'Copiar horario',
  'timetable.copy.title': 'Copiar horario a {group}',
  'timetable.copy.help':
    'Trae la semana de otro grupo: el mismo grupo el año pasado o un grupo paralelo. Cada bloque conserva el docente si tiene la asignación en {group}; si no, usa el docente asignado a esa asignatura. El aula se conserva si es de esta sede; un docente o un aula ocupados a esa hora quedan vacíos.',
  'timetable.copy.year': 'Año lectivo del origen',
  'timetable.copy.from': 'Grupo origen',
  'timetable.copy.noSource': 'No hay otro grupo de esta sede en ese año.',
  'timetable.copy.replace': 'Reemplazar el horario actual de {group} ({count} bloques)',
  'timetable.copy.submit': 'Copiar',
  'timetable.copy.done': 'Se copiaron {copied} bloques de {from}.',
  'timetable.copy.cleared':
    '{count} quedaron sin docente o sin aula porque estaban ocupados a esa hora:',
  'timetable.copy.cleared.teacher': 'Sin docente: {subject} el {day} de {start} a {end}',
  'timetable.copy.cleared.classroom': 'Sin aula: {subject} el {day} de {start} a {end}',
  'timetable.copy.skipped':
    '{count} bloques del origen no se copiaron porque se cruzaban con otro ya copiado.',
  'timetable.copy.dismiss': 'Entendido',
  'attendance.title': 'Asistencia',
  'attendance.filter.group': 'Grupo',
  'attendance.filter.date': 'Fecha',
  'attendance.caption': 'Asistencia del grupo',
  'attendance.column.student': 'Estudiante',
  'attendance.column.status': 'Estado',
  'attendance.column.note': 'Nota',
  'attendance.status.present': 'Presente',
  'attendance.status.absent': 'Ausente',
  'attendance.status.late': 'Tarde',
  'attendance.status.excused': 'Excusado',
  'attendance.status.unmarked': 'Sin marcar',
  'attendance.summary':
    '{present} presentes · {absent} ausentes · {late} tarde · {excused} excusados · {unmarked} sin marcar',
  'attendance.empty': 'Sin estudiantes matriculados en este grupo.',
  'attendance.tab.mark': 'Marcar',
  'attendance.tab.roll': 'Lista',
  'attendance.tab.excuses': 'Excusas',
  'attendance.tab.settings': 'Umbral y alertas',
  'attendance.filter.session': 'Sesión',
  'attendance.session.day': 'Todo el día',
  'attendance.session.none': 'El grupo no tiene clases en el horario ese día.',
  'attendance.mark.hint': 'Todos presentes. Toque un estudiante para cambiar su marca.',
  'attendance.mark.present': 'Asistió',
  'attendance.mark.absent': 'Faltó',
  'attendance.mark.late': 'Llegó tarde',
  'attendance.mark.excused': 'Excusado',
  'attendance.mark.counts':
    '{present} asistieron · {absent} faltaron · {late} llegaron tarde · {excused} excusados',
  'attendance.mark.allPresent': 'Todos presentes',
  'attendance.mark.save': 'Guardar asistencia',
  'attendance.mark.saved': 'Asistencia guardada ({count} cambios).',
  'attendance.mark.failed': 'No se guardó la asistencia.',
  'attendance.excuses.filter': 'Estado',
  'attendance.excuses.all': 'Todas (pendientes primero)',
  'attendance.excuses.list': 'Excusas',
  'attendance.excuses.empty': 'No hay excusas.',
  'attendance.excuses.emptyPending': 'No hay excusas pendientes.',
  'attendance.excuse.status.pending': 'Pendiente',
  'attendance.excuse.status.approved': 'Aprobada',
  'attendance.excuse.status.rejected': 'Rechazada',
  'attendance.excuse.range': 'Del {from} al {to}',
  'attendance.excuse.submitted': 'Enviada por {name} el {date}',
  'attendance.excuse.reviewed': 'Revisada por {name} el {date}',
  'attendance.excuse.file': 'Ver archivo: {filename}',
  'attendance.excuse.fileFailed': 'No se pudo abrir el archivo.',
  'attendance.excuse.approve': 'Aceptar',
  'attendance.excuse.reject': 'Rechazar',
  'attendance.review.approved.title': 'Aceptar la excusa de {student}',
  'attendance.review.rejected.title': 'Rechazar la excusa de {student}',
  'attendance.review.approve.body':
    'Las ausencias de {student} del {from} al {to} pasan a excusadas y la familia ve la excusa aprobada.',
  'attendance.review.reject.body': 'La familia ve la excusa rechazada, con la nota si la escribe.',
  'attendance.review.note': 'Nota para la familia (opcional)',
  'attendance.review.approved': 'Excusa aceptada: {count} ausencias pasaron a excusadas.',
  'attendance.review.rejected': 'Excusa rechazada.',
  'attendance.settings.title': 'Umbral de inasistencia',
  'attendance.settings.help':
    'Al alcanzarlo, el colegio recibe una alerta: una sola por estudiante y periodo, aunque siga faltando.',
  'attendance.settings.threshold': 'Inasistencia que alerta (%)',
  'attendance.settings.minimumMarks': 'Marcas mínimas en el periodo',
  'attendance.settings.default': 'El colegio usa los valores por omisión (20 % y 10 marcas).',
  'attendance.settings.current':
    'Alerta con {percent} % de inasistencia a partir de {marks} marcas en el periodo.',
  'attendance.settings.save': 'Guardar umbral',
  'attendance.settings.saved': 'Umbral guardado.',
  'attendance.alerts.title': 'Alertas de inasistencia',
  'attendance.alerts.empty': 'Ningún estudiante ha alcanzado el umbral.',
  'attendance.alerts.column.student': 'Estudiante',
  'attendance.alerts.column.group': 'Grupo',
  'attendance.alerts.column.period': 'Periodo',
  'attendance.alerts.column.absence': 'Inasistencia',
  'attendance.alerts.column.marks': 'Ausencias / marcas',
  'attendance.alerts.column.date': 'Fecha',
  'attendance.alerts.absence': '{percent} % (umbral {threshold} %)',
  'attendance.alerts.marks': '{absences} de {marks}',
  'grades.view.title': 'Calificaciones',
  'grades.view.filter.group': 'Grupo',
  'grades.view.filter.subject': 'Asignatura',
  'grades.view.filter.period': 'Periodo',
  'grades.view.caption': 'Calificaciones del grupo',
  'grades.view.column.student': 'Estudiante',
  'grades.view.column.final': 'Nota del periodo',
  'grades.view.column.national': 'Escala nacional',
  'grades.view.column.published': 'Publicada',
  'grades.view.empty': 'Sin estudiantes o sin evaluaciones para esta combinación.',
  'grades.view.weight': 'Peso {weight}',
  'grades.view.draft': 'Borrador',
  'grades.view.published': 'Publicada',
  'grades.view.scale': 'Escala {min} – {max}, aprueba con {pass}',
  'gradebook.tab.period': 'Nota del periodo',
  'gradebook.tab.scores': 'Digitar notas',
  'gradebook.tab.evaluations': 'Evaluaciones',
  'gradebook.state.published': 'Publicada el {date}',
  'gradebook.state.draft': 'Borrador: las familias no ven estas notas todavía.',
  'gradebook.state.locked':
    'Publicada: para cambiar evaluaciones, notas o ajustes, la rectoría debe reabrirla.',
  'gradebook.publish.subject': 'Publicar asignatura',
  'gradebook.publish.group': 'Publicar todo el grupo',
  'gradebook.publish.subject.title': 'Publicar {subject} de {group} en {period}',
  'gradebook.publish.group.title': 'Publicar todas las asignaturas de {group} en {period}',
  'gradebook.publish.subject.body':
    'Las familias verán la nota de {withGrade} estudiantes; {withoutGrade} sin nota quedan pendientes. Después nada de esta asignatura se puede cambiar sin reabrirla.',
  'gradebook.publish.group.body':
    'Se publican las notas que existen en todas las asignaturas del grupo. Después nada del periodo se puede cambiar sin reabrirlo.',
  'gradebook.publish.confirm': 'Sí, publicar',
  'gradebook.publish.done':
    'Se publicaron {published} notas; {withoutGrade} estudiantes sin nota quedaron pendientes.',
  'gradebook.publish.failed': 'No se publicaron las notas.',
  'gradebook.reopen': 'Reabrir',
  'gradebook.reopen.title': 'Reabrir {subject} de {group} en {period}',
  'gradebook.reopen.body':
    'Las familias dejan de ver estas notas hasta que se publiquen de nuevo. La razón queda en la auditoría.',
  'gradebook.reopen.reason': 'Razón',
  'gradebook.reopen.reasonRequired': 'Escriba la razón (al menos 3 letras).',
  'gradebook.reopen.done': 'Notas reabiertas: la asignatura vuelve a borrador.',
  'gradebook.reopen.failed': 'No se reabrieron las notas.',
  'gradebook.column.computed': 'Calculada',
  'gradebook.column.override': 'Ajuste',
  'gradebook.column.observation': 'Observación',
  'gradebook.column.actions': 'Acciones',
  'gradebook.adjust': 'Ajustar',
  'gradebook.adjust.title': 'Ajustar la nota del periodo de {student}',
  'gradebook.adjust.computed': 'Nota calculada: {grade}',
  'gradebook.adjust.score': 'Nota ajustada',
  'gradebook.adjust.scoreHelp': 'Vacía, la nota del periodo vuelve a la calculada.',
  'gradebook.adjust.observation': 'Observación',
  'gradebook.adjust.observationHelp': 'Obligatoria con un ajuste; el boletín la imprime.',
  'gradebook.adjust.observationRequired':
    'Para ajustar la nota escriba una observación que explique el ajuste.',
  'gradebook.adjust.done': 'Nota del periodo de {student} guardada.',
  'gradebook.adjust.failed': 'No se guardó el ajuste.',
  'gradebook.scores.evaluation': 'Evaluación',
  'gradebook.scores.none':
    'Esta asignatura no tiene evaluaciones en el periodo. Créelas en "Evaluaciones".',
  'gradebook.scores.hint':
    'Una nota por estudiante entre {min} y {max}, con {decimals} decimales. Enter o Tab bajan al siguiente estudiante; una casilla vacía borra la nota.',
  'gradebook.scores.caption': 'Notas de {evaluation}',
  'gradebook.scores.column.periodGrade': 'Nota del periodo',
  'gradebook.scores.column.score': 'Nota',
  'gradebook.scores.scoreOf': 'Nota de {student}',
  'gradebook.scores.issue.invalid': 'No es un número.',
  'gradebook.scores.issue.range': 'Fuera de la escala ({min} a {max}).',
  'gradebook.scores.issue.decimals': 'Máximo {decimals} decimales.',
  'gradebook.scores.invalid': '{count} notas por corregir antes de guardar.',
  'gradebook.scores.save': 'Guardar notas',
  'gradebook.scores.saved':
    'Notas guardadas: {scored} de {total} estudiantes con nota; la nota del periodo se recalculó.',
  'gradebook.scores.failed': 'No se guardaron las notas.',
  'gradebook.evaluations.caption': 'Evaluaciones del periodo',
  'gradebook.evaluations.empty': 'Sin evaluaciones en este periodo.',
  'gradebook.evaluations.new': 'Nueva evaluación',
  'gradebook.evaluations.edit': 'Editar evaluación',
  'gradebook.evaluations.column.name': 'Evaluación',
  'gradebook.evaluations.column.kind': 'Tipo',
  'gradebook.evaluations.column.weight': 'Peso',
  'gradebook.evaluations.column.dueOn': 'Fecha',
  'gradebook.evaluations.column.topics': 'Temas del plan',
  'gradebook.evaluations.column.scored': 'Con nota',
  'gradebook.evaluations.scored': '{scored} de {total}',
  'gradebook.evaluations.kind.activity': 'Actividad',
  'gradebook.evaluations.kind.exam': 'Examen',
  'gradebook.evaluations.field.name': 'Nombre',
  'gradebook.evaluations.field.kind': 'Tipo',
  'gradebook.evaluations.field.weight': 'Peso',
  'gradebook.evaluations.field.weightHelp':
    'Relativo a las demás evaluaciones del periodo: 40 y 60, o 1, 1 y 2.',
  'gradebook.evaluations.field.dueOn': 'Fecha (opcional)',
  'gradebook.evaluations.field.topics': 'Temas del plan que cubre',
  'gradebook.evaluations.topics.none':
    'El plan de estudios de esta asignatura para el grado no tiene temas.',
  'gradebook.evaluations.topics.period': 'Periodo {position}',
  'gradebook.evaluations.created': 'Evaluación creada.',
  'gradebook.evaluations.updated': 'Evaluación guardada.',
  'gradebook.evaluations.editAction': 'Editar',
  'gradebook.evaluations.delete': 'Eliminar',
  'gradebook.evaluations.delete.title': 'Eliminar {name}',
  'gradebook.evaluations.delete.body':
    'Se borran sus {scored} notas y la nota del periodo se recalcula sin ella.',
  'gradebook.evaluations.deleted': 'Evaluación eliminada.',
  'gradebook.evaluations.deleteFailed': 'No se eliminó la evaluación.',
  'gradebook.evaluations.weightSum': 'Suma de pesos: {sum}',
  'reportCard.title': 'Boletín',
  'reportCard.subtitle': '{year} · {period}',
  'reportCard.print': 'Imprimir',
  'reportCard.field.student': 'Estudiante',
  'reportCard.field.document': 'Documento',
  'reportCard.field.group': 'Grupo',
  'reportCard.field.homeroom': 'Director de grupo',
  'reportCard.field.period': 'Periodo',
  'reportCard.column.subject': 'Asignatura',
  'reportCard.column.teacher': 'Docente',
  'reportCard.column.score': 'Nota',
  'reportCard.column.national': 'Desempeño',
  'reportCard.column.observation': 'Observación',
  'reportCard.attendance': 'Asistencia del periodo',
  'reportCard.attendance.summary':
    '{days} días registrados · {present} presente · {absent} ausente · {late} tarde · {excused} excusado',
  'reportCard.draft': 'Nota en borrador (no publicada)',
  'reportCard.generated': 'Generado el {date}',
  'reportCard.preview':
    'Vista previa. El PDF con la marca del colegio llega en el módulo de boletines.',
  'reportCard.filter.period': 'Periodo',
  'reportCards.title': 'Boletines',
  'reportCards.filter.group': 'Grupo',
  'reportCards.filter.period': 'Periodo',
  'reportCards.students': '{count} estudiantes activos en {group}',
  'reportCards.empty': 'Este grupo no tiene estudiantes activos.',
  'reportCards.caption': 'Boletines del grupo',
  'reportCards.column.student': 'Estudiante',
  'reportCards.column.state': 'Boletín',
  'reportCards.column.actions': 'Acciones',
  'reportCards.state.generated': 'Generado',
  'reportCards.generate': 'Generar boletines',
  'reportCards.generate.title': 'Generar los boletines de {group} en {period}',
  'reportCards.generate.body':
    'Se generará el PDF de {count} estudiantes con las notas publicadas de {period}. Cada familia recibirá el aviso "Boletín disponible" una sola vez por periodo; un estudiante sin ninguna nota publicada queda como fallido, con el motivo.',
  'reportCards.generate.confirm': 'Sí, generar',
  'reportCards.generate.failed': 'No se pudieron generar los boletines.',
  'reportCards.batch.title': 'Lote de boletines de {period}',
  'reportCards.batch.status.queued': 'En cola',
  'reportCards.batch.status.running': 'Generando…',
  'reportCards.batch.status.done': 'Listo',
  'reportCards.batch.status.failed': 'Falló',
  'reportCards.batch.progress': '{generated} generados, {failed} fallidos de {total}',
  'reportCards.batch.errors': 'Boletines que fallaron',
  'reportCards.batch.error': 'El lote se detuvo: {message}',
  'reportCards.download': 'Descargar PDF',
  'reportCards.download.aria': 'Descargar el boletín de {name}',
  'reportCards.download.failed': 'No se pudo descargar el archivo; vuelva a intentarlo.',
  'reportCards.downloadAll': 'Descargar todos (ZIP)',
  'reportCards.downloadAll.progress': 'Descargando {done} de {total}…',
  'reportCards.downloadAll.done': 'ZIP con {count} boletines descargado.',
  'reportCards.downloadAll.partial':
    'ZIP con {count} boletines descargado; {failed} no se pudieron descargar:',
  'reportCards.downloadAll.none': 'Ningún boletín se pudo descargar.',
  'reportCards.downloadAll.failures': 'Boletines que no se descargaron',
  'announcements.title': 'Comunicados',
  'announcements.empty.title': 'Sin comunicados',
  'announcements.empty.body': 'Los comunicados del colegio a las familias aparecerán aquí.',
  'announcements.audience.all': 'Todo el colegio',
  'announcements.audience.sede': 'Sede {name}',
  'announcements.audience.grade': 'Grado {name}',
  'announcements.audience.group': 'Grupo {name}',
  'announcements.by': '{author} · {date}',
  'nav.mentoria': 'MentorIA',
  'nav.mentoriaDemo': 'MentorIA (demo)',
  'mentoria.title': 'MentorIA',
  'mentoria.disabled': 'MentorIA no está habilitado en este entorno.',
  'mentoria.context.title': 'Contexto de la sesión',
  'mentoria.context.help':
    'MentorIA solo recibe el nombre, el grado, la asignatura y el tema. Nada más sale del colegio.',
  'mentoria.field.student': 'Estudiante',
  'mentoria.field.subject': 'Asignatura',
  'mentoria.field.topic': 'Tema de estas semanas',
  'mentoria.noTopics': 'Sin temas para este grado y asignatura.',
  'mentoria.start': 'Iniciar sesión de estudio',
  'mentoria.newSession': 'Nueva sesión',
  'mentoria.chat.title': 'Conversación',
  'mentoria.chat.empty.title': 'Elija estudiante, asignatura y tema',
  'mentoria.chat.empty.body':
    'La sesión queda grabada con su costo; los acudientes podrán leerla desde la app.',
  'mentoria.chat.hint':
    '{name} puede preguntar lo que no entienda del tema. MentorIA explica, pregunta de vuelta y propone práctica; no hace la tarea.',
  'mentoria.chat.input': 'Escriba la pregunta',
  'mentoria.chat.send': 'Enviar',
  'mentoria.chat.sending': 'Enviando…',
  'mentoria.chat.failed': 'No se pudo enviar.',
  'mentoria.chat.retry': 'Reintentar',
  'mentoria.quota.remaining': 'Le quedan {n} mensajes este mes',
  'mentoria.quota.spent': 'La cuota mensual de MentorIA se agotó.',
  'mentoria.error': 'MentorIA no pudo responder.',
  'mentoria.footer':
    'Modelo: {model} · Última respuesta: {tokens} tokens en {latency} · Costo de la sesión: {cost}',
  'nav.assistant': 'Asistente docente',
  'nav.albert': 'Albert',
  'albert.title': 'Albert',
  'albert.intro':
    'Albert propone el plan de una clase, genera material y redacta desde sus viñetas. Todo se revisa antes de usarse; Albert nunca califica.',
  'albert.context.title': 'Clase y tema',
  'albert.field.pair': 'Grupo y asignatura',
  'albert.field.group': 'Grupo',
  'albert.field.subject': 'Asignatura',
  'albert.field.topic': 'Tema del plan de estudios',
  'albert.noClasses.title': 'Sin clases este año',
  'albert.noClasses.body':
    'Albert trabaja sobre los grupos y asignaturas que usted dicta. Cuando coordinación le asigne una clase, aparecerá aquí.',
  'albert.noTopics': 'Este grado y asignatura no tienen temas en el plan de estudios todavía.',
  'albert.pickTopic.title': 'Elija la clase y el tema',
  'albert.pickTopic.body':
    'Con el grupo, la asignatura y el tema elegidos, Albert planea, produce material y redacta.',
  'albert.quota.label': 'Cupo de Albert',
  'albert.quota': '{used} de {monthly} este mes',
  'albert.quota.unknown': 'se ve al elegir un tema',
  'albert.tab.plan': 'Plan de clase',
  'albert.tab.material': 'Material',
  'albert.tab.draft': 'Redactar',
  'albert.plan.focus': 'Énfasis (opcional)',
  'albert.plan.focus.help':
    'En sus palabras: "con dinero y recetas", "repaso antes de la evaluación".',
  'albert.plan.generate': 'Generar plan',
  'albert.plan.regenerate': 'Generar de nuevo',
  'albert.plan.regenerate.help': 'Pedirlo de nuevo reemplaza el plan guardado sobre el tema.',
  'albert.plan.working': 'Albert está escribiendo el plan…',
  'albert.plan.empty.title': 'Este tema no tiene plan todavía',
  'albert.plan.empty.body':
    'Pida el plan y Albert lo propone con objetivo, momentos, recursos, evaluación formativa y diferenciación; usted lo edita y lo guarda.',
  'albert.plan.editor': 'Plan guardado',
  'albert.plan.title': 'Título',
  'albert.plan.content': 'Contenido del plan',
  'albert.plan.save': 'Guardar cambios',
  'albert.plan.savedToast': 'Plan guardado.',
  'albert.plan.generatedToast': 'Plan generado y guardado sobre el tema.',
  'albert.plan.updatedAt': 'Guardado el {date}',
  'albert.plan.unsaved': 'Cambios sin guardar',
  'albert.material.kind': 'Tipo de material',
  'albert.material.kind.questions': 'Banco de preguntas',
  'albert.material.kind.worksheet': 'Guía de trabajo con rúbrica',
  'albert.material.kind.rubric': 'Rúbrica',
  'albert.material.level': 'Nivel',
  'albert.material.level.basico': 'Básico',
  'albert.material.level.medio': 'Medio',
  'albert.material.level.avanzado': 'Avanzado',
  'albert.material.notes': 'Notas de diferenciación (opcional)',
  'albert.material.notes.help':
    'Qué tener en cuenta: "tres estudiantes con apoyo en lectura", "ejemplos de la vereda".',
  'albert.material.generate': 'Generar material',
  'albert.material.working': 'Albert está armando el documento…',
  'albert.material.ready': 'Documento listo',
  'albert.material.download': 'Descargar',
  'albert.material.download.help':
    'El enlace dura 15 minutos y abre el documento en una pestaña nueva; se imprime desde el navegador.',
  'albert.material.size': '{kb} KB',
  'albert.material.recent': 'Documentos anteriores de este tema',
  'albert.material.recent.help':
    'Los generados desde este computador. "Nuevo enlace" pide otro enlace de descarga.',
  'albert.material.relink': 'Nuevo enlace',
  'albert.material.relinked': 'Enlace nuevo listo.',
  'albert.material.review':
    'Revise el documento antes de usarlo; se adjunta al tema desde el plan de estudios.',
  'albert.draft.kind': 'Qué redactar',
  'albert.draft.kind.observation': 'Observación de boletín',
  'albert.draft.kind.family-message': 'Mensaje a la familia',
  'albert.draft.student': 'Nombre de pila (opcional)',
  'albert.draft.student.help': 'Solo el nombre: nada de apellidos, documentos ni teléfonos.',
  'albert.draft.tone': 'Tono',
  'albert.draft.tone.cercano': 'Cercano',
  'albert.draft.tone.formal': 'Formal',
  'albert.draft.bullets': 'Viñetas',
  'albert.draft.bullets.help':
    'Una por línea, hasta doce: "participa poco", "mejoró en fracciones", "entrega tarde".',
  'albert.draft.generate': 'Redactar',
  'albert.draft.working': 'Albert está redactando…',
  'albert.draft.result': 'Texto para pegar',
  'albert.draft.result.help': 'Ajústelo aquí o péguelo donde va. No queda guardado.',
  'albert.draft.copy': 'Copiar texto',
  'albert.draft.copied': 'Texto copiado.',
  'albert.draft.copyFailed': 'No se pudo copiar; seleccione el texto y cópielo.',
  'albert.refusal.title': 'Albert no lo hizo',
  'albert.refusal.noGrading':
    'Albert no califica ni asigna notas ni puntajes. Quite ese pedido y vuelva a intentarlo.',
  'albert.refusal.quotaExhausted':
    'Se agotó el cupo de Albert de este mes. Vuelve el mes siguiente.',
  'albert.refusal.invalidOutput': 'La respuesta de Albert no sirvió esta vez. Pídala de nuevo.',
  'albert.refusal.personalData':
    'El texto trae datos personales (documentos, teléfonos). Quítelos: al modelo solo va un nombre de pila.',
  'albert.refusal.injection':
    'El texto trae instrucciones para el modelo. Escriba solo lo que quiere para la clase.',
  'albert.refusal.outsideScope': 'Ese grupo y asignatura no están entre sus clases de este año.',
  'albert.refusal.validation':
    'Revise lo escrito: el grupo debe ser del grado del tema y cada viñeta tener entre 2 y 240 caracteres.',
  'albert.retry': 'Reintentar',
  'albert.usage': 'Última respuesta: {tokens} tokens en {latency}',
} as const;
